var map = {
	"./Archive.svg": 1808,
	"./CPQQuote.svg": 1809,
	"./FINANCIALMANAGEMENT.svg": 1810,
	"./Feedback.svg": 1811,
	"./HOMEPAGE.svg": 1812,
	"./KNOWLEDGE.svg": 1813,
	"./Marketing.svg": 1814,
	"./ORDER.svg": 1815,
	"./ORDER2.svg": 1816,
	"./ORDER3.svg": 1817,
	"./ORDER4.svg": 1818,
	"./ORDER5.svg": 1819,
	"./ORDER6.svg": 1820,
	"./Report.svg": 1821,
	"./SALESMAN.svg": 1822,
	"./SALESMANAGEMENT.svg": 1823,
	"./Service.svg": 1824,
	"./SparePartsSales.svg": 1825,
	"./Statement.svg": 1826,
	"./WEB_BGXT.svg": 1827,
	"./arrow-down.svg": 1828,
	"./arrow-up.svg": 1829,
	"./arrow_down.svg": 1830,
	"./arrow_left.svg": 1831,
	"./arrow_right.svg": 1832,
	"./arrow_up.svg": 1833,
	"./attention-color.svg": 1834,
	"./canter_fill.svg": 1835,
	"./chart-bar_fill.svg": 1836,
	"./check-circle.svg": 1837,
	"./check.svg": 1838,
	"./close_line.svg": 1839,
	"./credit.svg": 1840,
	"./delete.svg": 1841,
	"./dilivers.svg": 1842,
	"./edit-square.svg": 1843,
	"./edit.svg": 1844,
	"./file-excel-fill.svg": 1845,
	"./file-image-fill.svg": 1846,
	"./file-music-fill.svg": 1847,
	"./file-pdf-fill.svg": 1848,
	"./file-ppt-fill.svg": 1849,
	"./file-unknown-fill.svg": 1850,
	"./file-word-fill.svg": 1851,
	"./heart-fill.svg": 1852,
	"./international.svg": 1853,
	"./knowledge base_fill.svg": 1854,
	"./loading.svg": 1855,
	"./lock.svg": 1856,
	"./menu.svg": 1857,
	"./minus-circle-fill.svg": 1858,
	"./mobile.svg": 1859,
	"./notification.svg": 1860,
	"./notification_fill.svg": 1861,
	"./order-form.svg": 1862,
	"./orders.svg": 1863,
	"./orders_fill.svg": 1864,
	"./plus-circle-fill.svg": 1865,
	"./rebate.svg": 1866,
	"./refund.svg": 1867,
	"./rt_button_return.svg": 1868,
	"./rt_list_select.svg": 1869,
	"./rt_menu_retract.svg": 1870,
	"./rt_menu_service.svg": 1871,
	"./rt_menu_shopping.svg": 1872,
	"./rt_menu_shopping_fill.svg": 1873,
	"./rt_menu_spread.svg": 1874,
	"./rt_menu_top.svg": 1875,
	"./rt_nav_message.svg": 1876,
	"./rt_success.svg": 1877,
	"./rt_tab_arrow_right.svg": 1878,
	"./rt_tab_line.svg": 1879,
	"./rt_tab_square.svg": 1880,
	"./rt_window_close.svg": 1881,
	"./safety.svg": 1882,
	"./sale canter_fill.svg": 1883,
	"./search.svg": 1884,
	"./setting-line.svg": 1885,
	"./square-dash-board-lined-other.svg": 1886,
	"./square-dash-board-lined.svg": 1887,
	"./square-four-lined-other.svg": 1888,
	"./square-four-lined.svg": 1889,
	"./star_fill.svg": 1890,
	"./star_line.svg": 1891,
	"./top_white.svg": 1892,
	"./user.svg": 1893,
	"./x.svg": 1894
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2283;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svgs nonrecursive ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}! .svg$
// module id = 2283
// module chunks = 137